export const NOTIFICATION_LOAD_SUCCESS = 'not/LOAD_SUCCESS';
export const NOTIFICATION_SET_BUSY = 'not/SET_BUSY';
export const NOTIFICATION_UNSET_BUSY = 'not/UNSET_BUSY';
export const NEW_NOTIFICATION_SAVED = 'notification/NEW_NOTIFICATION_SAVED';
export const NOTIFICATION_EDIT_SUCCESS = 'notification/NOTIFICATION_EDIT_SUCCESS';
export const NOTIFICATION_DELETE_SUCCESS = 'notification/NOTIFICATION_DELETE_SUCCESS';
